import React, { Children } from 'react';
import { classNames } from '../../../../utilities/css.js';
import { wrapWithComponent } from '../../../../utilities/components.js';
import styles from '../../FormLayout.scss.js';
import { Item } from '../Item/Item.js';
import { useUniqueId } from '../../../../utilities/unique-id/hooks.js';

function Group(_ref) {
  var children = _ref.children,
      condensed = _ref.condensed,
      title = _ref.title,
      helpText = _ref.helpText;
  var className = classNames(condensed ? styles.condensed : styles.grouped);
  var id = useUniqueId('FormLayoutGroup');
  var helpTextElement = null;
  var helpTextID;
  var titleElement = null;
  var titleID;

  if (helpText) {
    helpTextID = "".concat(id, "HelpText");
    helpTextElement =
    /*#__PURE__*/
    React.createElement("div", {
      id: helpTextID,
      className: styles.HelpText
    }, helpText);
  }

  if (title) {
    titleID = "".concat(id, "Title");
    titleElement =
    /*#__PURE__*/
    React.createElement("div", {
      id: titleID,
      className: styles.Title
    }, title);
  }

  var itemsMarkup = Children.map(children, function (child) {
    return wrapWithComponent(child, Item, {});
  });
  return (
    /*#__PURE__*/
    React.createElement("div", {
      role: "group",
      className: className,
      "aria-labelledby": titleID,
      "aria-describedby": helpTextID
    }, titleElement,
    /*#__PURE__*/
    React.createElement("div", {
      className: styles.Items
    }, itemsMarkup), helpTextElement)
  );
}

export { Group };